import React, { useState } from "react";
import {
	Box,
	useTheme,
	useMediaQuery,
	Dialog,
	Backdrop
} from "@material-ui/core";
import { Play as PlayIcon } from 'react-feather';
import { getBoxMarginProps, getBreakpointValue } from "./functions";
import YouTubePlayer from "../YouTubePlayer";
import { getYoutubeVideoId } from "src/utils/functions";

export const Video = (props) => {
	const theme = useTheme();
	const breakpoint = useMediaQuery(theme.breakpoints.only('xs')) ? 'xs' : 'md';

	const [videoDialogIsOpen, setVideoDialogIsOpen] = useState(false);
	const openVideoDialog = () => setVideoDialogIsOpen(true);
	const closeVideoDialog = () => setVideoDialogIsOpen(false);

	const width = getBreakpointValue(props, breakpoint, 'width');
	const height = getBreakpointValue(props, breakpoint, 'height');
	const videoId = getYoutubeVideoId(props.url);

	return (
		<Box
			{...getBoxMarginProps(props, breakpoint)}
			textAlign={getBreakpointValue(props, breakpoint, 'textAlign')}
			width="100%"
			height="100%"
		>
			<Box
				onClick={openVideoDialog}
				sx={{
					width: '100%',
					height: '100%',
					maxWidth: Number(width),
					maxHeight: Number(height),
					aspectRatio: '15 / 9',
					backgroundSize: 'cover',
					backgroundImage: `url(https://img.youtube.com/vi/${videoId}/hqdefault.jpg)`,
					backgroundPosition: 'center',
					backgroundColor: 'rgba(0, 0, 0, 0.4)',
					backgroundBlendMode: 'overlay',
					transition: 'background-color .3s',
					display: 'inline-flex',
					justifyContent: 'center',
					alignItems: 'center',
					cursor: 'pointer',
					'&:hover': {
						backgroundColor: 'rgba(0, 0, 0, 0.2)',
					},
					[theme.breakpoints.down('md')]: {
						maxWidth: '100%',
						maxHeight: '100%',
					},
				}}
			>
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						backgroundColor: 'rgba(0, 0, 0, 0.5)',
						borderRadius: '50%',
						width: '120px',
						height: '120px',
						transition: 'background .3s',
						'& svg': {
							color: '#fff',
							fill: '#fff',
							width: '60px',
							height: '60px',
						},
					}}
				>
					<PlayIcon />
				</Box>
			</Box>
			<Dialog
				disableRestoreFocus
				open={videoDialogIsOpen}
				onClose={closeVideoDialog}
				PaperProps={{
					sx: {
						width: '100%',
						maxWidth: '70vw',
						height: '100%',
						maxHeight: '80vh',
						[theme.breakpoints.down('md')]: {
							maxHeight: Number(height),
							maxWidth: Number(width),
						}
					},
				}}
			>
				<YouTubePlayer videoId={videoId} autoplay={true} />
				<Backdrop />
			</Dialog>
		</Box>
	);
}
